import React from "react";
import { useAuth } from "../../../context/AuthContext";
import "../../../styles/components/landingPage/header/StoryCounter.css";

const StoryCounter: React.FC = () => {
  const { user, userProfile, loadingProfile } = useAuth();

  /** ---------- Premium‑Status ---------- */
  const subs = userProfile?.subscription;
  const isPremium =
    subs?.status === "active" &&
    (subs.basePlan !== "free" || (subs.addOns?.length ?? 0) > 0);

  /** ---------- Restliches Kontingent berechnen ---------- */
  const quotaReads = subs?.quotas?.pdfReads ?? null;           // z. B. 10 oder 20
  const usedReads = userProfile?.usage?.pdfReadsThisMonth ?? 0;
  const remainingReads =
    quotaReads !== null ? Math.max(quotaReads - usedReads, 0) : null;

  /** ---------- Reset‑Zeitpunkt (falls vorhanden) ---------- */
  // Wir gehen davon aus, dass counterReset in Firestore als Timestamp vorliegt
  // und als Date per toDate() im userProfile gespeichert wird.
  const resetDate: Date | null =
    userProfile && "counterReset" in userProfile
      ? // @ts-ignore – einfach akzeptieren, falls vorhanden
        (userProfile.counterReset?.toDate?.() ?? userProfile.counterReset ?? null)
      : null;

  const getTimeUntilReset = () => {
    if (!resetDate) return "";
    const diffMs = resetDate.getTime() - Date.now();
    if (diffMs <= 0) return "Wird zurückgesetzt...";
    const days = Math.floor(diffMs / 86_400_000);
    const hours = Math.floor((diffMs / 3_600_000) % 24);
    const minutes = Math.floor((diffMs / 60_000) % 60);
    return `${days ? `${days}d ` : ""}${hours ? `${hours}h ` : ""}${
      minutes ? `${minutes}m` : ""
    }`.trim();
  };

  /** ---------- Render‑Logik ---------- */
  const renderCounter = () => {
    if (!user) return null;

    if (isPremium) return <span className="counter-infinity">∞</span>;

    if (loadingProfile || remainingReads === null)
      return <span className="counter-loading">Lädt...</span>;

    if (remainingReads > 0)
      return <span className="counter-number">{remainingReads}</span>;

    return (
      <span className="counter-zero" title={`Reset in: ${getTimeUntilReset()}`}>
        0
      </span>
    );
  };

  return <div className="story-counter">{renderCounter()}</div>;
};

export default StoryCounter;
